import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="contact-info">
          <h3>{t("footer.getInTouch")}</h3>
          <div className="contact-details">
            <p>
              <span>📧</span>
              <a href="mailto:dritselifoteini@gmail.com">dritselifoteini@gmail.com</a>
            </p>
            <p>
              <span>📞</span>
              <a href="tel:+31627904800">+31 627904800 (NL)</a>
            </p>
            <p>
              <span>📍</span>
              {t("footer.location")}
            </p>
            <p>
              <span>⏰</span>
              {t("footer.available")}
            </p>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="legal-links">
          <Link to="/privacy-policy">{t("footer.privacy")}</Link>
          <Link to="/terms-of-service">{t("footer.terms")}</Link>
        </div>
        <div className="company-details">
          <p>{t("footer.vatId")}: NL005486047B08</p>
          <p>{t("footer.kvk")}: 42087706</p>
        </div>
        <p className="copyright">
          &copy; {currentYear} Foteini Dritseli. {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
